// The company being worked on (Luminara Investments; this app is Luminara's own). The choice is remembered on this browser.
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { applyBrand } from "@/lib/site";

const Ctx = createContext(null);

function remembered() {
  try { return localStorage.getItem("company") || ""; } catch { return ""; }
}

export function CompanyProvider({ children }) {
  const [companies, setCompanies] = useState(null);
  const [id, setId] = useState(remembered());
  const reload = useCallback(async () => {
    const { data } = await api.get("/companies");
    setCompanies(data);
    return data;
  }, []);
  useEffect(() => { reload().catch(() => setCompanies([])); }, [reload]);
  const company = (companies || []).find((c) => c.id === id) || (companies || [])[0] || null;
  useEffect(() => { if (company?.brand_color) applyBrand(company.brand_color); }, [company]);
  const choose = (cid) => {
    setId(cid);
    try { localStorage.setItem("company", cid); } catch { /* private window */ }
  };
  return <Ctx.Provider value={{ companies, company, choose, reload }}>{children}</Ctx.Provider>;
}

export const useCompany = () => useContext(Ctx);
